import { amsterdamDay } from './activity';

export async function findAvailableDay(getDays, current, direction, hasData, signal, target = null) {
  if (direction !== -1 && direction !== 1) throw new Error('Ongeldige datumrichting');
  let anchor = current;
  if (target) {
    const inclusive = new Date(`${target}T12:00:00Z`);
    inclusive.setUTCDate(inclusive.getUTCDate() - direction);
    anchor = inclusive.toISOString().slice(0, 10);
  }
  while (true) {
    signal?.throwIfAborted();
    const days = await getDays(anchor, direction);
    signal?.throwIfAborted();
    const candidates = [...new Set(days)].filter(day =>
      day <= amsterdamDay() && (direction < 0 ? day < anchor : day > anchor)
    ).sort();
    if (direction < 0) candidates.reverse();
    const day = candidates[0];
    if (!day) return null;
    if (await hasData(day, signal)) {
      signal?.throwIfAborted();
      return day;
    }
    anchor = day;
  }
}

export function matchesSessionSearch(session, query = '') {
  const search = query.trim().toLowerCase();
  return session.transponder.toLowerCase().includes(search) ||
    (session.nickname ?? '').toLowerCase().includes(search);
}
